import "./public-path.js";
import React from "react";
import ReactDOMClient from "react-dom/client";
import Root from "./root.component.js";
import singleSpaReact from "single-spa-react";
import singleSpaCanopy from "single-spa-canopy";
import { ReplaySubject } from "rxjs";
import { initialize as initializeMessageCounts } from "./dashboard/message-counts.resource.js";

const reactLifecycles = singleSpaReact({
  React,
  ReactDOMClient,
  rootComponent: Root,
  domElementGetter,
});

const canopyLifecycles = singleSpaCanopy({
  domElementGetter,
  mainContentTransition: false,
  hotload: {
    module,
    // @ts-expect-error provided by webpack
    __webpack_require__: typeof __webpack_require__ === "undefined" ? null : __webpack_require__,
    dev: {
      enabled: true,
      waitForUnmount: false,
    },
  },
  overlay: {
    background: `rgba(18, 100, 232, 0.1)`,
  },
});

export function getBannerNotificationsController() {
  return import(
    /*webpackChunkName: "banner-notifications-controller" */ "./exports/banner-notifications/banner-notifications-controller.component.js"
  );
}

export const bootstrap = [
  function () {
    initializeMessageCounts();
    return Promise.resolve();
  },
  canopyLifecycles.bootstrap,
  reactLifecycles.bootstrap,
];

export const mount = [reactLifecycles.mount, canopyLifecycles.mount];

export const unmount = [reactLifecycles.unmount, canopyLifecycles.unmount];

export const unload = [canopyLifecycles.unload];

// This will be used by primary navbar
export const globalUnreadNotifications = new ReplaySubject(1);
globalUnreadNotifications.next(0);

export { initialize as initializeMessageCounts } from "./dashboard/message-counts.resource.js";

function domElementGetter() {
  let el = document.getElementById("notifications-ui");
  if (!el) {
    el = document.createElement("div");
    el.setAttribute("id", "notifications-ui");
    document.body.insertBefore(el, document.body.childNodes[0]);
  }

  return el;
}

export function loadNotificationMessage() {
  return import(
    /*webpackChunkName: "notifications-message-component" */ "src/messages/message-modals/notification-message.component.js"
  ).then((mod) => mod);
}
